<template>
  <div>
    <div class="credit-alert">
      <component
        :is="tag"
        :title="title"
        :class="['credit-alert__item', `text-${color}`]"
        v-b-popover.hover.top="tooltip"
        :cta_id="cta_id"
      >
        <span class="credit-alert__text" v-html="text">
        </span>
        <vb-icon
          v-if="icon"
          class="credit-alert__icon ml-1"
          :name="'vb-chat'"
          :color="sass('info')"
          :size="18"
        />
      </component>
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "credit-alert",
  props: {
    icon: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Credito non sufficiente",
    },
    title: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: "",
    },
    tag: {
      type: String,
      default: "div",
      validator: (value) => ["a", "div", "customer-support-action"].includes(value),
    },
    color: {
      type: String,
      default: "secondary",
    },
    cta_id: {
      type: String,
      default: "credit-alert",
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-alert {
  display: flex;
  align-items: baseline;
  flex-direction: column;

  @include media-breakpoint-up(xl) {
    font-size: $font-size-sm;
  }

  &__item {
    font-weight: $vb-font-weight-semibold;
  }
}
</style>
